import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "../../../../../../../../common/hook";
import {Preloader} from "../../../../../../../layout/preloader/Preloader";
import {StudentsLessonsItems} from "./students-lessons-items/StudentsLessonsItems";
import {CustomPagination} from "../../../../../../../pagination/CustomPagination";
import {NothingYetMessage} from '../../../../../../personal-cabinet/nothing-yet-message/NothingYetMessage';
import {
    fetchStudentLessons
} from "../../../../../../../../features/model/service/student-info/student-info-lessons/fetchStudentInfoLessons";
import {useParams} from "react-router-dom";


export const StudentsLessons = () => {
    const dispatch = useAppDispatch()
    const {groupId, studentId} = useParams();
    const studentLessonsState = useAppSelector((state) => state.studentLessons);
    const {items, isLoading, error} = studentLessonsState;
    const paginationData = useAppSelector((state) => state.studentLessons.pagination);
    const {page, pageSize, pageCount} = paginationData;


    useEffect(() => {
        dispatch(fetchStudentLessons({groupId, studentId}));
    }, [dispatch]);


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchStudentLessons({groupId, studentId, page: value - 1}));
    };


    return (
        <div className="tabs-content">
            <div className="tab">
                <div className="data-tbl individual-student-lessons-tbl">
                    <div className="row thead">
                        <div className="col presence-col">Присутствие</div>
                        <div className="col lesson-col auto-width full-width-mobile">Занятие</div>
                        <div className="col status-col">Статус</div>
                        <div className="col lessont-time-col auto-width">Время занятия</div>
                    </div>

                    {isLoading ? (
                        <Preloader/>
                    ) : items && items.length > 0 ? (
                        items?.map((lesson) => (
                            <StudentsLessonsItems key={lesson.id} lesson={lesson}/>
                        ))
                    ) : (
                        <NothingYetMessage/>
                    )}

                    {pageCount > 1 && (
                        <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle}/>
                    )}
                </div>
            </div>
        </div>
    );
};


// {isLoading ? (
//     <Preloader />
// ) : items === null || items?.length === 0 ? (
//     <NothingYetMessage />
// ) : (
//     items?.map((lesson) => (
//         <StudentsLessonsItems key={lesson.id} lesson={lesson} />
//     ))
// )}